module.exports = require("ensure-start");;